import { JSEncrypt } from 'jsencrypt';
import { publicOne } from './publicOne';
import { publicTwo } from './publicTwo';

const RES_PUBLIC_KEY = publicOne + 'S2' + publicTwo;
const encrypt = new JSEncrypt();
encrypt.setPublicKey(RES_PUBLIC_KEY);
const MAX_ENCRYPT_SIZE = 117;

const stringSplitFunc = str => {
  if (str.length < MAX_ENCRYPT_SIZE) return [str];
  const strArr = [];
  let len = 0;
  // eslint-disable-next-line
  while (true) {
    const endSize = MAX_ENCRYPT_SIZE + len;
    const s = str.substring(len, endSize);
    if (s.length === 0) break;
    strArr.push(s);
    len = endSize;
  }
  return strArr;
};
const stringArrayEncryptFunc = strArr => strArr.map(item => encrypt.encrypt(item));
const encryptFn = (val, withTimeStamp? = false) => {
  let jsonStringify = val;
  if (typeof val !== 'string') {
    jsonStringify = JSON.stringify(val);
  }
  if (withTimeStamp) {
    // 在数据的尾部带上毫秒级别时间戳
    jsonStringify += `#${new Date().getTime()}`;
  }
  const stringSplit = stringSplitFunc(jsonStringify);
  const a = stringArrayEncryptFunc(stringSplit).join(',');
  return a;
};
export default encryptFn;
